<template>
  <el-table class="common-el-table-styles" :data="data" :height="height" v-loading="loading" border stripe>
    <el-table-column
      v-for="(col, id) in columns"
      :key="id"
      :prop="col.key"
      :label="col.title"
      show-overflow-tooltip
      :min-width="col.width"
      :align="col.align"
    >
      <template slot-scope="scope">
        <div v-if="col.key === 'state'">
          <Poptip confirm transfer :title="popTitleTxt(scope.row.status)" @on-ok="switchPlan(scope.row)">
            <i class="cover-mask"></i>
            <i-Switch :value="scope.row.status" size="small" :true-value="1" :false-value="0" />
          </Poptip>
        </div>
        <div v-else-if="col.key === 'ruleDesc'">
          <span class="block-span g-error-text">{{ scope.row['dataRange'] | rangeType }}{{ scope.row['monitorType'] | satisType }}</span>
          <span class="block-span" v-for="(cond, i) in scope.row[col.key]" :key="i">{{ cond }}</span>
        </div>
        <div v-else-if="col.key === 'control'">
          <el-button type="text" size="small" @click="editClick(scope.row)">修改规则</el-button>&ensp;
          <el-button type="text" size="small" @click="copyClick(scope.row)" class="c-control-margin">复制</el-button>
        </div>
        <div v-else-if="col.key === 'alertType'">
          <span class="block-span g-error-text">{{ scope.row[col.key] | alertType }}</span>
          <span class="block-span">{{ scope.row['monitorTime'] | timeType }}</span>
        </div>
        <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
        <span v-else-if="col.key === 'lastRpTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
        <span v-else>{{ scope.row[col.key] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { switchPreWarnStatus } from '@/api/manage.model'
export default {
  name: 'monitorTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    height: {
      type: Number
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    }
  },
  methods: {
    popTitleTxt(state) {
      const txt = state ? '关闭' : '开启'
      return `确定要${txt}此预警规则吗？`
    },
    switchPlan(row) {
      const { id, status } = row
      const changStat = status ? 0 : 1
      switchPreWarnStatus({
        id,
        status: changStat
      }).then((data) => {
        if (data) {
          this.$set(row, 'status', changStat)
          this.$emit('on-refresh')
        }
      })
    },
    editClick(row) {
      const { id } = row
      const query = { id, t: 'edit' }
      this.$router.push({ name: 'prewarnedit', query })
    },
    copyClick(row) {
      const { id } = row
      this.$router.push({ name: 'prewarnadd', query: { id } })
    }
  },
  filters: {
    alertType(val) {
      let type
      switch (val) {
        case 1:
          type = '仅钉钉'
          break
        case 2:
          type = '仅邮件'
          break
        case 3:
          type = '邮件+钉钉'
          break
        default:
          type = '未启用'
          break
      }
      return type
    },
    timeType(val) {
      let timeTxt = ''
      const monitorTime = typeof val === 'string' && JSON.parse(val)
      timeTxt = `每天 ${monitorTime.value}`
      return timeTxt
    },
    rangeType(val) {
      let type
      switch (val) {
        case 0:
          type = '今日实时；'
          break
        case 1:
          type = '昨天数据；'
          break
        case 2:
          type = '近3天数据；'
          break
        case 3:
          type = '近7天数据；'
          break
        case 4:
          type = '上一周数据；'
          break
        case 5:
          type = '上一月数据；'
          break
        default:
          type = '未知数据；'
          break
      }
      return type
    },
    satisType(val) {
      if (val === 'all') return '全部条件'
      else return '任意条件'
    }
  }
}
</script>
<style lang="scss" scoped>
.block-span {
  display: block;
}

.c-control-margin {
  margin: 0;
  padding: 0 3px;
}

.ivu-poptip {
  position: relative;

  .cover-mask {
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 3;
    cursor: pointer;
  }
}
</style>
